"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PageHeader = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(PageHeader, _PureComponent);

  var _super = _createSuper(PageHeader);

  function PageHeader() {
    (0, _classCallCheck2["default"])(this, PageHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(PageHeader, [{
    key: "resolveComponents",
    value: function resolveComponents() {
      var breadcrumb = null;
      var title = null;
      var actions = null;
      var children = this.props.children;
      (0, _forEach["default"])(_react.Children).call(_react.Children, children, function (child) {
        if ( /*#__PURE__*/(0, _react.isValidElement)(child)) {
          if (child.type.displayName === _constants.DISPLAY_NAME_BREADCRUMB) {
            breadcrumb = child;
          } else if (child.type.displayName === _constants.DISPLAY_NAME_TITLE) {
            title = child;
          } else if (child.type.displayName === _constants.DISPLAY_NAME_ACTIONS) {
            actions = child;
          }
        }
      });
      return {
        title: title,
        breadcrumb: breadcrumb,
        actions: actions
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$resolveComponen = this.resolveComponents(),
          breadcrumb = _this$resolveComponen.breadcrumb,
          title = _this$resolveComponen.title,
          actions = _this$resolveComponen.actions;

      var dataTestId = this.props.dataTestId;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(this.props, "oui-page-header")
      }, (breadcrumb !== null || title !== null) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-header-left"
      }, breadcrumb, title), actions));
    }
  }]);
  return PageHeader;
}(_react.PureComponent);

PageHeader.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  dataTestId: _propTypes["default"].string
};
PageHeader.defaultProps = {
  dataTestId: "orion-page-header"
};
PageHeader.displayName = _constants.DISPLAY_NAME_HEADER;
var _default = PageHeader;
exports["default"] = _default;